<h3-annotation-layout
  [class.with-side-views]="withSideViews$ | async"
  [class.split-view]="isInSplitView$ | async"
  [class.new-toolbar]="isObjectsEnabled"
>
  <h3-main-point-cloud-renderer
    projection-location="main-image"
    *h3Injector="contentInjector"
    [size]="size$ | async"
    [isThumbnail]="(isThumbnail$ | async) === true"
    [withSideViews]="withSideViews$ | async"
    [isSingleFrameTask]="isSingleFrameTask$ | async"
  ></h3-main-point-cloud-renderer>

  <div
    class="right-collapsing-section"
    projection-location="right-collapsing-section"
    *ngIf="(status$ | async) === 'ready'"
  >
    <h3-shape-list-and-tag-editor
      *ngIf="(isInSplitView$ | async) !== true"
    ></h3-shape-list-and-tag-editor>
  </div>

  <h3-cv-toolbar
    projection-location="global-toolbar"
    *ngIf="
      isObjectsEnabled &&
      (isSelectedOutput$ | async) &&
      (isInSplitView$ | async) === false
    "
  ></h3-cv-toolbar>

  <h3-measure-toolbar
    projection-location="measure-toolbar"
    *h3Injector="contentInjector"
  ></h3-measure-toolbar>

  @if (!isObjectsEnabled) {
    <div
      projection-location="toolbars"
      *ngIf="(status$ | async) === 'ready'"
      [hidden]="hideToolbars$ | async"
      class="toolbars overlay"
    >
      <h3-side-view-toggle-button
        *ngIf="(isInSplitView$ | async) !== true"
      ></h3-side-view-toggle-button>
      <h3-measure-toolbar *h3Injector="contentInjector"></h3-measure-toolbar>
      <div class="toolbar-grid">
        <div
          *ngIf="isInSplitView$ | async"
          id="point-cloud-layout-split-view"
          class="layout-row split-view"
        >
          <h3-split-view-main-point-cloud-toolbar
            *h3Injector="contentInjector"
          ></h3-split-view-main-point-cloud-toolbar>
          <mat-button-toggle-group
            class="ground-button"
            *h3Injector="contentInjector"
            [multiple]="true"
          >
            <mat-button-toggle
              (click)="toggleHideGround()"
              [checked]="settingStore('hideGround').$ | async"
              matTooltip="Toggle Ground"
            >
              <fa-icon [fixedWidth]="true" [icon]="faMinusSquare"></fa-icon>
            </mat-button-toggle>
          </mat-button-toggle-group>
          <h3-help-button></h3-help-button>
        </div>
        <div class="layout-row" *ngIf="(isInSplitView$ | async) === false">
          <h3-secondary-toolbar-3d
            *h3Injector="contentInjector"
          ></h3-secondary-toolbar-3d>
          <div class="output-controls">
            <h3-point-cloud-layer-view-settings *h3Injector="contentInjector">
            </h3-point-cloud-layer-view-settings>

            <h3-view-settings-3d
              *h3Injector="contentInjector"
            ></h3-view-settings-3d>
            <h3-enhanced-point-cloud-button></h3-enhanced-point-cloud-button>

            <h3-inspect-button></h3-inspect-button>

            <h3-undo-redo-buttons
              *ngIf="(readOnly$ | async) !== true"
            ></h3-undo-redo-buttons>

            <h3-help-button></h3-help-button>
            <h3-show-feedback-button></h3-show-feedback-button>
            <h3-right-collapsing-button
              *ngIf="(this.isRightPanelExpanded$ | async) === false"
            ></h3-right-collapsing-button>
          </div>
        </div>
        <div class="layout-row" *ngIf="(isInSplitView$ | async) === false">
          <h3-main-point-cloud-toolbar-objectless
            *h3Injector="contentInjector"
          ></h3-main-point-cloud-toolbar-objectless>
        </div>
      </div>
    </div>
  }

  <div
    projection-location="timeline-section"
    *ngIf="(status$ | async) === 'ready' && (isInSplitView$ | async) === false"
  >
    <div class="layout-row">
      <h3-focusable-scrubber></h3-focusable-scrubber>
    </div>
  </div>
</h3-annotation-layout>
